"use client";

import React from "react";

export default function ErrorMessage({ action } : { action: () => void }) {
    return (
        <div className="w-full h-screen flex items-center justify-center p-10">
            <div className="rounded-xl bg-white p-10 md:px-20 md:py-14 text-center">
                <h2 className="text-3xl font-semibold text-zinc-900 leading-snug">
                    We're sorry, an error has occurred.
                </h2>
                <p className="text-zinc-900 text-lg py-4 leading-snug">
                    Please try again by refreshing the browser window or by clicking the button below.
                </p>
                <button onClick={() => action()} className="mt-6 inline-flex items-center justify-center px-6 py-3 rounded-md text-normal text-center font-jost font-semibold outline-2 outline-offset-2 transition-colors text-lg text-white bg-black hover:bg-black/80 whitespace-nowrap">
                    Reload this page
                </button>
            </div>
        </div>
    );
}